import { getAuthToken } from "../utils/localStorage";
import { apiConfig, authConfig } from "./apiConfig";

export const loginUser = async (userData) => {
    try {
        const response = await apiConfig.post('login', userData, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};


export const logoutUser = async () => {
    try {
      const token = getAuthToken();
      const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, // Pass the Bearer token here
      };
      const response = await authConfig.post(`logout`, {}, { headers })
      return response;
    } catch (error) {
      throw error;
    }
  };